// extracted by mini-css-extract-plugin
var _1 = "ApplicantIdentityWidgetFormFields-moduleApplicantIdentityWidgetFormFields__sArEH";
var _2 = "ApplicantIdentityWidgetFormFields-modulefields__JVFQf FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "ApplicantIdentityWidgetFormFields", _2 as "fields" }
